import $ from 'jquery';

function init() {
  $('.recentProjects__preview').hover(
    function hoverIn() {
      const $projectPreviewInfo = $(this).find('.recentProjects__info');
      $projectPreviewInfo
        .removeClass('animateZoomOut')
        .addClass('animateZoomIn');
    },
    function hoverOut() {
      const $projectPreviewInfo = $(this).find('.recentProjects__info');
      $projectPreviewInfo
        .removeClass('animateZoomIn')
        .addClass('animateZoomOut');
    }
  );
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/recent_projects/recent_projects.js
 **/